import styled from 'styled-components'

export const TitleStyle = styled.h1`
  margin: 15px 0;
  text-align: center;
  color: ${({ theme }) => {
    return theme.colors.primary
  }};
  font-size: ${({ theme }) => {
    return theme.fonts.size.extraBig
  }};
  font-weight: ${({ theme }) => {
    return theme.fonts.weight.thin
  }};

  @media screen and (max-width: 720px) {
    margin: 8px 0;
    font-size: ${({ theme }) => {
      return theme.fonts.size.big
    }};
  }

  @media screen and (max-width: 480px) {
    margin: 4px 0;
    font-size: ${({ theme }) => {
      return theme.fonts.size.normal
    }};
  }
`
